import { viewType } from '../../core/view/data-view.js';
import { GanttSingleView } from './gantt-view-manager.js';
import type { GanttViewData } from './types.js';

export const ganttViewType = viewType('gantt');

export const ganttViewModel = ganttViewType.createModel<GanttViewData>({
  defaultName: 'Инфокарта',
  dataViewManager: GanttSingleView,
  defaultData: viewManager => ({
    filter: {
      type: 'group',
      op: 'and',
      conditions: [],
    },
    date: {
      startColumnId: viewManager.dataSource.properties$.value.find(id => {
        const type = viewManager.dataSource.propertyTypeGet(id);
        return type === 'date' || type === 'date-range';
      }),
    },
    header: {
      titleColumn: viewManager.dataSource.properties$.value.find(
        id => viewManager.dataSource.propertyTypeGet(id) === 'title'
      ),
    },
  }),
});
